import createEnum from 'scripts/lib/create_enum';

export const NotificationSoundType = createEnum(
  'AGENT_NOTIFICATION',
  'DECLINED_SESSION_REASSIGNMENT',
  'INBOUND_MESSAGE',
  'PAYMENT_STATUS_EVENT'
);
